<template>
  <Error code="404" />
</template>

<script>

export default {
  name: 'error',
}
</script>

<style scoped>

</style>
